import { MdTrendingUp } from "react-icons/md";


const DashboardCard = ({ title, subtitle, value, icon: Icon, trend, trendValue, color = "blue" }) => {

  const colorClasses = {
    blue: "from-blue-500 to-indigo-600",
    green: "from-green-500 to-emerald-600",
    purple: "from-purple-500 to-violet-600",
    orange: "from-orange-500 to-red-500"
  };

  return (
    <div className="group relative overflow-hidden">
      <div className="relative p-6 bg-gradient-to-br from-white via-gray-50 to-blue-50/30 rounded-2xl border border-gray-200/60 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02]">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-500/10 to-indigo-500/10 rounded-full blur-2xl group-hover:scale-150 transition-transform duration-500"></div>
        
        {/* Content */}
        <div className="relative z-10">
          {/* Header with icon */}
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 bg-gradient-to-r ${colorClasses[color]} rounded-xl flex items-center justify-center shadow-lg`}>
              <Icon className="text-white text-lg" />
            </div>
            {trend && (
              <div className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${
                trend === 'up' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
              }`}>
                <MdTrendingUp className={`transform ${trend === 'down' ? 'rotate-180' : ''}`} />
                <span>{trendValue}</span>
              </div>
            )}
          </div>
          
          {/* Title */}
          <h5 className="text-sm font-medium text-gray-600 uppercase tracking-wide mb-2">
            {title}
          </h5>
          
          {/* Value */}
          <h2 className="text-4xl lg:text-5xl font-black bg-gradient-to-r from-gray-800 via-blue-900 to-indigo-900 bg-clip-text text-transparent leading-none mb-3">
            {value}
          </h2>
          
          {/* Subtitle */}
          <div className="flex items-center gap-2">
            <div className="flex-1 h-px bg-gradient-to-r from-gray-300 to-transparent"></div>
            <h6 className="text-sm text-gray-500 font-medium whitespace-nowrap">
              {subtitle}
            </h6>
            <div className="flex-1 h-px bg-gradient-to-l from-gray-300 to-transparent"></div>
          </div>
        </div>
        
        {/* Hover accent line */}
        <div className={`absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r ${colorClasses[color]} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left rounded-full`}></div>
      </div>
    </div>
  );
};

export default DashboardCard